<button pButton class="p-button-text btn-document" (click)="documentApi === 'getContractPdf' ? openContract() : openConsentReport()"> {{ name }} </button>
